import { FunctionalComponent, h } from 'preact';
import { IconProps } from 'ui/icons/icon';

export const ExitIcon: FunctionalComponent<IconProps> = (props) => {
	const { size = 18, fill = '#595959' } = props;

	return (
		<svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M13.5 4.5L4.5 13.5" stroke={fill} stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M4.5 4.5L13.5 13.5" stroke={fill} stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
	);
};
